<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                 class="demo-ruleForm">
            <el-row style="margin-top: 0">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="card-base baslikBg animated fadeInLeft">Hasta Bilgileri</div>

                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='İsim Soyisim :' prop="adSoyad">
                                    <el-input
                                            v-model="hastaForm.adSoyad"
                                            v-on:input="inputStyleAlt(hastaForm.adSoyad)"
                                            placeholder='İsim Soyisim Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item class="gosterme" label='T.C. No : ' prop="tcNo"
                                              :rules="[
      { required: hastaForm.dosyaNo === ''  &&  hastaForm.protokolNo === '',  message: 'required', trigger: ['blur', 'change'] }]">
                                    <el-input  v-on:change="bilgiKontrol('tcNo')" :disabled="this.hastaForm.dosyaNo !=='' || this.hastaForm.protokolNo !== ''"
                                              v-model="hastaForm.tcNo" v-mask="'###########'"
                                              placeholder='T.C. No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item class="gosterme" label='Dosya No : ' prop="dosyaNo"
                                              :rules="[
      { required: hastaForm.tcNo === ''  &&  hastaForm.protokolNo === '',  trigger: ['blur', 'change'] }]"
                                >
                                    <el-input v-on:change="bilgiKontrol('dosyaNo')" :disabled="this.hastaForm.tcNo !=='' || this.hastaForm.protokolNo !== ''"
                                              v-model="hastaForm.dosyaNo" v-mask="'#######'"
                                              placeholder='Dosya No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item class="gosterme" label='Protokol No : ' prop="protokolNo"
                                              :rules="[
      { required: hastaForm.tcNo === ''  &&  hastaForm.dosyaNo === '', trigger: ['blur', 'change'] }]"
                                >
                                    <el-input v-on:change="bilgiKontrol('protokolNo')" :disabled="this.hastaForm.tcNo !=='' || this.hastaForm.dosyaNo !== ''"
                                              v-model="hastaForm.protokolNo" v-mask="'#######'"
                                              placeholder='Protokol No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='E-Posta :' prop="eposta">
                                    <el-input
                                            v-model="hastaForm.eposta"
                                            placeholder='E-Posta Giriniz'></el-input>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Telefon :' prop="telefon">
                                    <el-input
                                            v-mask="'+90(###)### ## ##'"
                                            v-model="hastaForm.telefon"
                                            placeholder='Telefon Giriniz'></el-input>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='İl :' prop="il">
                                    <el-select
                                            auto-complete="disable"
                                            v-model="hastaForm.il"
                                            filterable
                                            v-on:change="getIlSelect"
                                            placeholder='İl Seçiniz'
                                            style="width: 100%">
                                        <el-option v-for="item in ilList"
                                                   :key="item.baslik"
                                                   :label="item.baslik"
                                                   :value="item.ilId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Yaş :' prop="yas">
                                    <el-input
                                            v-model="hastaForm.yas"
                                            v-mask="'##'"
                                            placeholder='Yaş Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Cinsiyet :' prop="cinsiyet">
                                    <el-row :gutter="10" style="margin-top: 0">
                                        <el-col :lg="12" :md="12" :sm="12" :xs="24">
                                            <el-radio style="width: 100%; margin-right: 0 !important;"
                                                      v-model="hastaForm.cinsiyet" label="Kadın"
                                                      border
                                                      size="medium">
                                                <i style="color: deeppink;" class="mdi mdi-human-female"></i> Kadın
                                            </el-radio>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="12" :xs="24" class="mobil-margin">
                                            <el-radio style="width: 100%; margin-left: 0 !important;"
                                                      v-model="hastaForm.cinsiyet" label="Erkek"
                                                      border
                                                      size="medium">
                                                <i style="color: #337ab7;" class="mdi mdi-human-male"></i> Erkek
                                            </el-radio>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="card-base baslikBg margin-top-20 animated fadeInLeft">Ürün Bilgileri</div>

                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">

                                <el-form-item label='Ürün Kodu :' :prop="hastaForm.urunList.urunKodu"
                                              :rules="{ required: true, message: 'Lütfen Ürün Kodu Seçiniz', trigger: 'change'}">
                                    <el-select
                                            filterable
                                            v-model="hastaForm.urunList.urunKodu"
                                            placeholder='Ürün Kodu Seçiniz'
                                            v-on:change="getUrunDetay"
                                            style="width: 100%">
                                        <el-option v-for="item in oUrunList"
                                                   :key="item.urunKodu"
                                                   :label="item.urunKodu"
                                                   :value="item.oUrunId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Ürün Adı : ' prop="urunAdi">
                                    <el-input disabled
                                              v-model="hastaForm.urunList.urunAdi"
                                              placeholder='Ürün Adı Giriniz'></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Referans No : ' prop="referansNo">
                                    <el-input disabled
                                              v-model="hastaForm.urunList.referansNo"
                                              placeholder='Referans No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Barkod No : ' prop="barkodNo">
                                    <el-input disabled
                                              v-model="hastaForm.urunList.barkodNo"
                                              placeholder='Barkod No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='SUT Kodu : ' prop="sutKodu">
                                    <el-input disabled
                                              v-model="hastaForm.urunList.sutKodu"
                                              placeholder='SUT Kodu Giriniz'></el-input>
                                </el-form-item>
                            </el-col>


                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="card-base baslikBg margin-top-20 animated fadeInLeft">Uygulama Bilgileri</div>

                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="col-p">
                                <div class="margin-top-30">
                                    <el-tooltip class="item" effect="dark" :open-delay="200" content="Hekim Ekle" placement="top">
                                        <el-button v-on:click="dialogVisibleHekim=true" size="mini" plain
                                                   type="warning" icon="el-icon-plus" class="mobil-doktor-buton">
                                        </el-button>
                                    </el-tooltip>
                                </div>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label="Uygulama Tarihi : " :prop="hastaForm.uygulamaList.tarih"
                                              :rules="{ required: true, message: 'Lütfen Uygulama Tarihi Seçiniz', trigger: 'change'}">
                                    <el-date-picker
                                            style="width: 100%"
                                            v-model="hastaForm.uygulamaList.tarih"
                                            type="datetime"
                                            :picker-options="dateRangeOptions"
                                            format="yyyy-MM-dd HH:mm:ss"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="Uygulama Tarihi Seçiniz"
                                            default-time="12:00:00">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>


                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">

                                <el-form-item label='Hekim Adı :' :prop="hastaForm.uygulamaList.hekimAdi"
                                              :rules="{ required: true, message: 'Lütfen Hekim Adı Seçiniz', trigger: 'change'}">
                                    <el-select
                                            v-model="hastaForm.uygulamaList.hekimAdi"
                                            placeholder='Hekim Seçiniz'
                                            v-on:change="hetHekimKlinikList"
                                            style="width: 100%">
                                        <el-option v-for="item in oHekimList"
                                                   :key="item.adSoyad"
                                                   :label="item.adSoyad"
                                                   :value="item.hekimId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Klinik Adı : ' :prop="hastaForm.uygulamaList.klinik"
                                              :rules="{ required: true, message: 'Lütfen Klinik Seçiniz', trigger: 'change'}">
                                    <el-select
                                            v-model="hastaForm.uygulamaList.klinik"
                                            placeholder='Klinik Adı Seçiniz'
                                            style="width: 100%">
                                        <el-option v-for="item in oHekimKlinikList"
                                                   :key="item.baslik"
                                                   :label="item.baslik"
                                                   :value="item.klinikId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <el-button v-on:click="hastaTanimlama" class="margin-bottom-50 estas-buton ileriButton" size="small"
                               type="primary"
                               style="float: right;margin-top: 15px;">
                        Kaydet
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                    </el-button>
                </el-col>

            </el-row>
            <hekim-tanimlama v-if="dialogVisibleHekim" :dialogvisible.sync="dialogVisibleHekim"></hekim-tanimlama>
        </el-form>
    </div>
</template>

<script>
    import urunOrtopediService from "../../../WSProvider/UrunOrtopediService";
    import notification from "../../../notification";
    import hekimService from "../../../WSProvider/HekimService";
    import hastaOrtopediService from "../../../WSProvider/HastaOrtopediService";
    import ilService from "../../../WSProvider/IlService";
    import HekimTanimlama from "../../../components/HekimTanimlama";


    export default {
        name: "OrtopediHastaKayit",

        components: {
            HekimTanimlama
        },
        data() {
            return {
                hastaForm: {
                    adSoyad: '',
                    yas: '',
                    cinsiyet: '',
                    eposta: '',
                    telefon: '',
                    il: '',
                    tcNo: '',
                    dosyaNo: '',
                    protokolNo: '',

                    urunList: {
                        urunKodu: '',
                        referansNo: '',
                        barkodNo: '',
                        urunAdi: '',
                        sutKodu: '',
                    },

                    uygulamaList: {
                        tarih: '',
                        hekimAdi: '',
                        klinik: '',
                    }
                },

                dateRangeOptions: {
                    firstDayOfWeek: 1,
                    disabledDate: this.disabledDate
                },

                ilList: [],
                oUrunList: [],
                oHekimList: [],
                oHekimKlinikList: [],

                bilgiTuru: '',
                bilgi: '',

                dialogVisibleHekim: false,

                rulesHasta: {
                    // tcNo: [{
                    //     required: true,
                    //     message: "Lütfen T.C. No Giriniz",
                    //     trigger: 'change'
                    // }],
                    adSoyad: [{
                        required: true,
                        message: "Lütfen İsim Soyisim Giriniz.",
                        trigger: 'change'
                    }],
                    yas: [{
                        required: true,
                        message: "Lütfen Yaş Seçiniz.",
                        trigger: 'change'
                    }],
                    cinsiyet: [{
                        required: true,
                        message: "Lütfen Cinsiyet Seçiniz.",
                        trigger: 'change'
                    }],
                    // dosyaNo: [{
                    //     required: true,
                    //     message: "Lütfen Dosya No Giriniz.",
                    //     trigger: 'change'
                    // }],
                    // protokolNo: [{
                    //     required: true,
                    //     message: "Lütfen Protokol No Giriniz.",
                    //     trigger: 'change'
                    // }],
                    il: [{
                        required: true,
                        message: "Lütfen Telefon Giriniz.",
                        trigger: 'change'
                    }],
                },
            }
        },

        mounted() {
            this.getoUrunList();
            this.getIl()
        },

        methods: {
            bilgiKontrol(gelenBilgi) {
                switch (gelenBilgi) {
                    case 'tcNo':
                        this.bilgiTuru = "TC No";
                        this.bilgi = this.hastaForm.tcNo;
                        break;
                    case 'dosyaNo':
                        this.bilgiTuru = "Dosya No";
                        this.bilgi = this.hastaForm.dosyaNo;
                        break;
                    case 'protokolNo':
                        this.bilgiTuru = "Protokol No";
                        this.bilgi = this.hastaForm.protokolNo;
                        break;
                }
            },


            hastaTanimlama() {

                var dizi = [{}];
                dizi.push(this.hastaForm.urunList.urunKodu);

                // this.$refs.hastaForm.validate((valid) => {
                //     if (valid) {
                hastaOrtopediService.hastaOrtopediKaydi(this.hastaForm.uygulamaList.hekimAdi, this.hastaForm.uygulamaList.klinik, this.bilgi, this.bilgiTuru, this.hastaForm.adSoyad, this.hastaForm.yas, this.hastaForm.cinsiyet, this.hastaForm.eposta, this.hastaForm.telefon, this.hastaForm.il, this.hastaForm.uygulamaList.tarih, dizi).then((response) => {
                    if (response.status === 200) {
                        this.$refs['hastaForm'].resetFields();
                        this.hastaForm = {
                            adSoyad: '',
                            yas: '',
                            cinsiyet: '',
                            eposta: '',
                            telefon: '',
                            il: '',
                            tcNo: '',
                            dosyaNo: '',
                            protokolNo: '',

                            urunList: {
                                urunKodu: '',
                                referansNo: '',
                                barkodNo: '',
                                urunAdi: '',
                                sutKodu: '',
                            },

                            uygulamaList: {
                                tarih: '',
                                hekimAdi: '',
                                klinik: '',
                            }
                        };
                        notification.Status('success', this, 'Hasta kaydı başarıyla oluşturuldu.');
                    } else notification.Status(response.status, this)
                })
                //     }
                // })

            },

            getUrunDetay(val) {
                urunOrtopediService.urunOrtopediDetay(val).then((response) => {
                    if (response.status === 200) {
                        this.hastaForm.urunList.referansNo = response.data.referansNo;
                        this.hastaForm.urunList.sutKodu = response.data.sutKodu;
                        this.hastaForm.urunList.urunAdi = response.data.urunAdi;
                        this.hastaForm.urunList.barkodNo = response.data.barkodNo;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getoUrunList() {
                urunOrtopediService.urunOrtopediListesi("1", "", "").then((response) => {
                    if (response.status === 200) {
                        this.oUrunList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getIlSelect(gelenIlId) {
                hekimService.hekimIlList(gelenIlId).then((response) => {
                    if (response.status === 200) {
                        this.oHekimList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            hetHekimKlinikList(val) {
                hekimService.hekimDetay(val).then((response) => {
                    if (response.status === 200) {
                        this.oHekimKlinikList = response.data.klinik;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            }
        },


    }
</script>

<style lang="scss">
    .gosterme .el-form-item__error {
        display: none !important;
    }
    .gosterme .el-input__suffix {
        display: none !important;
    }

</style>